import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { accountFeature, AccountEffects } from './store';

export function provideAccountFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(accountFeature), provideEffects(AccountEffects)]);
}
